import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function FloatingTools() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useState(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed right-6 bottom-6 z-40 flex flex-col gap-4">
      {/* 电话咨询 */}
      <a 
        href="tel:4009885286"
        className="group w-14 h-14 flex items-center justify-center bg-blue-900 text-white rounded-full shadow-lg hover:scale-110 transition-all duration-300 hover:shadow-xl"
      >
        <i className="ri-phone-line text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          电话咨询
        </span>
      </a>

      {/* 联系我们 */}
      <Link
        to="/contact"
        className="group w-14 h-14 flex items-center justify-center bg-white text-blue-900 rounded-full shadow-lg hover:scale-110 transition-all duration-300 hover:shadow-xl border-2 border-blue-900"
      >
        <i className="ri-contacts-line text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          联系我们
        </span>
      </Link>

      {/* 回到顶部 */}
      {showBackToTop && (
        <button
          onClick={scrollToTop}
          className="group w-14 h-14 flex items-center justify-center bg-gray-200 text-gray-700 rounded-full shadow-lg hover:scale-110 transition-all duration-300 hover:bg-gray-300"
        >
          <i className="ri-arrow-up-line text-2xl"></i>
          <span className="absolute right-16 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            回到顶部
          </span>
        </button>
      )}
    </div>
  );
}